import { render, staticRenderFns } from "./ylservice.vue?vue&type=template&id=22b68242&scoped=true&"
import script from "./ylservice.vue?vue&type=script&lang=js&"
export * from "./ylservice.vue?vue&type=script&lang=js&"
import style0 from "./ylservice.vue?vue&type=style&index=0&id=22b68242&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b68242",
  null
  
)

export default component.exports